import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { SidebarNavigationComponent } from './sidebar-navigation/sidebar-navigation.component';
import { DocumentPickerComponent } from './document-picker/document-picker.component';
import { ReservationPickerComponent } from './reservation-picker/reservation-picker.component';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { BuddyModule } from '../buddy/buddy.module';
import { ModalPopupComponent } from './modal-popup/modal-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { CountryComponent } from './country/country.component';
import { StateComponent } from './state/state.component';
import { AngularMaterialModule } from '../../material.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { StatusPillComponent } from './status-pill/status-pill.component';
import { BalanceComponent } from './balance/balance.component';
import { ListItemComponent } from './list-item/list-item.component';
import { UploaderComponent } from './uploader/uploader.component';
import { UploaderPreviewComponent } from './uploader-preview/uploader-preview.component';
import { MaticonComponent } from './maticon/maticon.component';
import { FontAwesomeIconComponent } from './font-awesome-icon/font-awesome-icon.component';
import { IconComponent } from './icon/icon.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { MtxNativeDatetimeModule } from '@ng-matero/extensions/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorComponent } from './validation-error/validation-error.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { HighlightPipe } from './pipe/highlight.pipe';
import { PhoneMaskDirective } from './directives/phone-mask/phone-mask.directive';
import { ZipcodeMaskDirective } from './directives/zipcode/zipcode-mask.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTableComponent } from './mat-table/mat-table.component';
import { AddressComponent } from './form-field/address/address.component';
import { SelectBoxComponent } from './form-field/select-box/select-box.component';
import { LoadDataGridDirective } from './directives/load-data-grid.directive';
import { ActionDropdownComponent } from './action-dropdown/action-dropdown.component';
import { CustomerContactSelectionDropdownComponent } from './form-field/customer-contact-selection-dropdown/customer-contact-selection-dropdown.component';
import { CurrencyMaskDirective } from './directives/currency-mask/currency-mask.directive';
import { NaturalCurrencyMaskDirective } from './directives/currency-mask/natural-currency-mask.directive';
import { DecimalMaskDirective } from './directives/decimal-mask/decimal-mask.directive';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { SearchFieldComponent } from './input-components/search-field/search-field.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AttachmentComponent } from './attachment/attachment.component';
import { TemplateViewComponent } from './template-view/template-view.component';
import { GooglePlaceDirective } from 'src/app/modules/shared/directives/google-places-autocomplete/google-places-autocomplete.directive';
import { SearchPipe } from './pipe/search.pipe';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { PermissionsDirective } from './directives/permissions/permissions.directive';
import { FinancialBlurDirective, FinancialVisibleDirective } from './directives/financial/financial-permission.directive';
import { ModuleTicketsComponent } from './module-tickets/module-tickets.component';
import { TicketDetailPopupComponent } from './module-tickets/ticket-detail-popup/ticket-detail-popup.component';
import { ScrollableSearchFieldComponent } from './input-components/scrollable-search-field/scrollable-search-field.component';
import { MatSelectModule } from '@angular/material/select';
import { ExportPdfSharedComponent } from './export-pdf/export-pdf.component';
import { PDFDisplayOptionsComponent } from './pdf-display-option/pdf-display-option.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgForFilterPipe } from './pipe/filters/ng-for-filter.pipe';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { PositiveValueMaskDirective } from './directives/positive-value-mask/positive-value-mask.directive';
import { TruncatePipe } from './pipe/truncate.pipe';
import { StatusTextColorPipe } from './pipe/status-text-color.pipe';
import { ReadableTextOnWhitePipe } from './pipe/readable-text-on-white.pipe';
import { AddEditVendorQuotesComponent } from './vendor-quotes/add-edit-vendor-quotes/add-edit-vendor-quotes.component';
import { SelectVendorQuoteDialogComponent } from './vendor-quotes/select-vendor-quote-dialog/select-vendor-quote-dialog.component';
import { ApplyVendorQuotesDialogComponent } from './vendor-quotes/apply-vendor-quotes-dialog/apply-vendor-quotes-dialog.component';
import { CompareVendorQuoteChangesDialogComponent } from './vendor-quotes/compare-vendor-quote-changes-dialog/compare-vendor-quote-changes-dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AccountBalanceChartComponent } from './account-balance-chart/account-balance-chart.component';
import { EchartModule } from '../echart/echart.module';
import { ShowDataPointWithTooltipComponent } from '../widgets/show-data-point-with-tooltip/show-data-point-with-tooltip.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ModuleOfficeSelectionComponent } from './module-office-selection/module-office-selection.component';
import { CityValueMaskDirective } from './directives/city-value-mask/city-value-mask.directive';
import { TakeoffsScaleComponent } from './form-field/takeoffs-scale/takeoffs-scale.component';
import { ScrollableMultipleSearchFieldComponent } from './input-components/scrollable-multiple-search-field/scrollable-multiple-search-field.component';
import { AppendToBodyDirective } from './directives/append-to-body/append-to-body.directive';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { AvatarGroupComponent } from './avatar-group/avatar-group.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { ProfileAvatarComponent } from './profile-avatar/profile-avatar.component';
import { UserHoverCardComponent } from './user-hover-card/user-hover-card.component';
import { StatisticsDropdownComponent } from './header/statistics-dropdown/statistics-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { WatcherComponent } from './watcher/watcher.component';
import { QuickCreateComponent } from './header/quick-create/quick-create.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { ActionsBarComponent } from './actions-bar/actions-bar.component';
import { EmailLauncherComponent } from '../email/email-launcher/email-launcher.component';
import { MatButtonModule } from '@angular/material/button';
import { TaskDropdownComponent } from './header/task-dropdown/task-dropdown.component';
import { ModuleDocumentsComponent } from './module-documents/module-documents.component';
import { ModuleNotesPanelComponent } from './module-notes-panel/module-notes-panel.component';
import { ModuleMilestoneSelectorComponent } from './module-milestone-selector/module-milestone-selector.component';
import { JobsiteGalleryComponent } from './jobsite-gallery/jobsite-gallery.component';
import { FileThumbnailComponent } from './file-thumbnail/file-thumbnail.component';
import { MediaUploadDialogComponent } from './media-upload-dialog/media-upload-dialog.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ProjectTimelineActivityComponent } from './project-timeline-activity/project-timeline-activity.component';
import { MilestonePhaseCardComponent } from './milestone-phase-card/milestone-phase-card.component';
import {
  ScheduleModule,
  RecurrenceEditorModule,
} from '@syncfusion/ej2-angular-schedule';
import {
  ToolbarModule,
  SidebarModule,
  TabModule,
  TreeViewModule,
} from '@syncfusion/ej2-angular-navigations';
import { SliderModule } from '@syncfusion/ej2-angular-inputs';
import { SplitButtonModule, DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import {
  CalendarModule,
  TimePickerModule,
} from '@syncfusion/ej2-angular-calendars';
import { ListViewModule } from '@syncfusion/ej2-angular-lists';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {
  TextBoxModule,
  ColorPickerModule as SyncfusionColorPickerModule,
} from '@syncfusion/ej2-angular-inputs';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ChangePasswordComponent } from './header/change-password/change-password.component';
import { VideoPreviewComponent } from './video-preview/video-preview.component';
import { AudioPreviewComponent } from './audio-preview/audio-preview.component';
import { DocCommentSidebarComponent } from '../document/document-image-annotator/doc-comment-sidebar.component';
import { EmailComposeDirective } from './directives/email-compose.directive';
import { PdfPreviewComponent } from './pdf-preview/pdf-preview.component';
import { PreviewHeaderComponent } from './preview-header/preview-header.component';
import { PreviewLoadingComponent } from './preview-loading/preview-loading.component';
import { RemindersModule } from './reminders/reminders.module';
import { ActivityPanelModule } from './header/activity-panel/activity-panel.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ModuleEmailsComponent } from './module-emails/module-emails.component';
import { HeaderEmailSidebarComponent } from './header/header-email-sidebar/header-email-sidebar.component';
import { HeaderEmailSidebarService } from './header/header-email-sidebar/header-email-sidebar.service';
import { PTOApprovalQueueDialogComponent } from './header/pto-approval-queue-dialog/pto-approval-queue-dialog.component';
import { TwoFactorPromptComponent } from './two-factor-prompt/two-factor-prompt.component';
import { GlobalSearchComponent } from './header/global-search/global-search.component';
import { ScreenshotCaptureOverlayComponent } from './screenshots/screenshot-capture-overlay/screenshot-capture-overlay.component';
import { CaptureToastComponent } from './screenshots/capture-toast/capture-toast.component';
import { ScreenshotPanelComponent } from './screenshots/screenshot-panel/screenshot-panel.component';
import { ScreenshotCardComponent } from './screenshots/screenshot-panel/screenshot-card/screenshot-card.component';
import { ScreenshotAnnotatorComponent } from './screenshots/screenshot-annotator/screenshot-annotator.component';
import { ScreenshotShareDialogComponent } from './screenshots/screenshot-share-dialog/screenshot-share-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MentionModule } from 'angular-mentions';
// Reusable presentational task UI components — shared so the milestone task dialog
// can reuse the exact same header/main-content UI as the Task module's add-task.
import { TaskHeaderComponent } from '../sale/task/add-task/task-header/task-header.component';
import { TaskMainContentComponent } from '../sale/task/add-task/task-main-content/task-main-content.component';
// Consolidates the many per-widget spinners inside a tabbed detail screen into a
// single centered spinner per tab.
import { TabLoadingScopeComponent } from './tab-loading-scope/tab-loading-scope.component';
import { ActivityTickerComponent } from './activity-ticker/activity-ticker.component';


@NgModule({
  declarations: [
    LayoutComponent,
    SidebarNavigationComponent,
    DocumentPickerComponent,
    ReservationPickerComponent,
    HeaderComponent,
    ModalPopupComponent,
    CountryComponent,
    StateComponent,
    ConfirmationPopupComponent,
    StatusBadgeComponent,
    StatusPillComponent,
    BalanceComponent,
    ListItemComponent,
    UploaderComponent,
    UploaderPreviewComponent,
    MaticonComponent,
    FontAwesomeIconComponent,
    IconComponent,
    DateTimePickerComponent,
    ValidationErrorComponent,
    SvgIconComponent,
    SafeHtmlPipe,
    HighlightPipe,
    PhoneMaskDirective,
    PositiveValueMaskDirective,
    ZipcodeMaskDirective,
    AddressComponent,
    MatTableComponent,
    SelectBoxComponent,
    LoadDataGridDirective,
    ActionDropdownComponent,
    CustomerContactSelectionDropdownComponent,
    CurrencyMaskDirective,
    NaturalCurrencyMaskDirective,
    DecimalMaskDirective,
    MainLayoutComponent,
    SearchFieldComponent,
    AttachmentComponent,
    TemplateViewComponent,
    SearchPipe,
    AccessDeniedComponent,
    PermissionsDirective,
    FinancialBlurDirective,
    FinancialVisibleDirective,
    ModuleTicketsComponent,
    TicketDetailPopupComponent,
    ScrollableSearchFieldComponent,
    ExportPdfSharedComponent,
    PDFDisplayOptionsComponent,
    NgForFilterPipe,
    PositiveValueMaskDirective,
    AddEditVendorQuotesComponent,
    SelectVendorQuoteDialogComponent,
    ApplyVendorQuotesDialogComponent,
    CompareVendorQuoteChangesDialogComponent,
    AccountBalanceChartComponent,
    ShowDataPointWithTooltipComponent,
    CityValueMaskDirective,
    TakeoffsScaleComponent,
    ImagePreviewComponent,
    ModuleOfficeSelectionComponent,
    ScrollableMultipleSearchFieldComponent,
    AvatarGroupComponent,
    ProfileAvatarComponent,
    UserHoverCardComponent,
    StatisticsDropdownComponent,
    WatcherComponent,
    QuickCreateComponent,
    CalculatorComponent,
    ActionsBarComponent,
    TaskDropdownComponent,
    ModuleDocumentsComponent,
    ModuleNotesPanelComponent,
    TaskDropdownComponent,
    ModuleMilestoneSelectorComponent,
    MediaUploadDialogComponent,
    JobsiteGalleryComponent,
    FileThumbnailComponent,
    CalendarComponent,
    ProjectTimelineActivityComponent,
    MilestonePhaseCardComponent,
    ChangePasswordComponent,
    VideoPreviewComponent,
    AudioPreviewComponent,
    PdfPreviewComponent,
    MilestonePhaseCardComponent,
    AppendToBodyDirective,
    HeaderEmailSidebarComponent,
    PTOApprovalQueueDialogComponent,
    ModuleEmailsComponent,
    TwoFactorPromptComponent,
    GlobalSearchComponent,
    StatusTextColorPipe,
    ReadableTextOnWhitePipe,
    ScreenshotCaptureOverlayComponent,
    CaptureToastComponent,
    ScreenshotPanelComponent,
    ScreenshotCardComponent,
    ScreenshotAnnotatorComponent,
    ScreenshotShareDialogComponent,
    TaskHeaderComponent,
    TaskMainContentComponent,
    TabLoadingScopeComponent,
    ActivityTickerComponent,
  ],
  imports: [
    DragDropModule,
    PreviewHeaderComponent,
    PreviewLoadingComponent,
    EmailLauncherComponent,
    DocCommentSidebarComponent,
    EmailComposeDirective,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    // Buddy — the AI companion. Exports <app-buddy-host> (mounted in MainLayout)
    // and <app-buddy-glance> (the header popover).
    BuddyModule,
    MatDialogModule,
    MatMenuModule,
    AngularMaterialModule,
    MatAutocompleteModule,
    // for dateTime Start
    MtxDatetimepickerModule,
    MtxNativeDatetimeModule,
    // for dateTime End
    NgSelectModule,
    GooglePlaceDirective,
    MatSelectModule,
    MatExpansionModule,
    CKEditorModule,
    TruncatePipe,
    MatButtonToggleModule,
    EchartModule,
    MatSnackBarModule,
    MatTooltipModule,
    NgxTippyModule,
    MatIconModule,
    MatButtonModule,
    InfiniteScrollModule,
    TimePickerModule,
    ScheduleModule,
    RecurrenceEditorModule,
    ToolbarModule,
    SidebarModule,
    CalendarModule,
    ListViewModule,
    GridModule,
    DialogModule,
    TextBoxModule,
    RemindersModule,
    ActivityPanelModule,
    TabModule,
    TreeViewModule,
    SliderModule,
    SplitButtonModule,
    DropDownButtonModule,
    MatCheckboxModule,
    MentionModule,
    ],
  exports: [
    EmailComposeDirective,
    LayoutComponent,
    SidebarNavigationComponent,
    HeaderComponent,
    ModalPopupComponent,
    CountryComponent,
    StateComponent,
    ConfirmationPopupComponent,
    StatusBadgeComponent,
    StatusPillComponent,
    BalanceComponent,
    ListItemComponent,
    UploaderComponent,
    UploaderPreviewComponent,
    IconComponent,
    DateTimePickerComponent,
    ValidationErrorComponent,
    AddressComponent,
    MatTableComponent,
    PhoneMaskDirective,
    PositiveValueMaskDirective,
    ZipcodeMaskDirective,
    SelectBoxComponent,
    LoadDataGridDirective,
    ActionDropdownComponent,
    CustomerContactSelectionDropdownComponent,
    CurrencyMaskDirective,
    NaturalCurrencyMaskDirective,
    DecimalMaskDirective,
    SearchFieldComponent,
    AttachmentComponent,
    TemplateViewComponent,
    SearchPipe,
    HighlightPipe,
    NgForFilterPipe,
    PermissionsDirective,
    FinancialBlurDirective,
    FinancialVisibleDirective,
    ModuleTicketsComponent,
    ModuleTicketsComponent,
    ScrollableSearchFieldComponent,
    PDFDisplayOptionsComponent,
    CKEditorModule,
    AccountBalanceChartComponent,
    ShowDataPointWithTooltipComponent,
    CityValueMaskDirective,
    ModuleOfficeSelectionComponent,
    ScrollableMultipleSearchFieldComponent,
    AvatarGroupComponent,
    ProfileAvatarComponent,
    UserHoverCardComponent,
    StatisticsDropdownComponent,
    WatcherComponent,
    ActionsBarComponent,
    ExportPdfSharedComponent,
    ModuleDocumentsComponent,
    ModuleNotesPanelComponent,
    ExportPdfSharedComponent,
    ModuleDocumentsComponent,
    MediaUploadDialogComponent,
    JobsiteGalleryComponent,
    FileThumbnailComponent,
    CalendarComponent,
    ProjectTimelineActivityComponent,
    MilestonePhaseCardComponent,
    GooglePlaceDirective,
    RemindersModule,
    ActivityPanelModule,
    AppendToBodyDirective,
    TwoFactorPromptComponent,
    MatProgressSpinnerModule,
    HeaderEmailSidebarComponent,
    ModuleEmailsComponent,
    GlobalSearchComponent,
    VideoPreviewComponent,
    AudioPreviewComponent,
    PdfPreviewComponent,
    StatusTextColorPipe,
    ReadableTextOnWhitePipe,
    ScreenshotCaptureOverlayComponent,
    CaptureToastComponent,
    ScreenshotPanelComponent,
    ScreenshotCardComponent,
    ScreenshotAnnotatorComponent,
    ScreenshotShareDialogComponent,
    TaskHeaderComponent,
    TaskMainContentComponent,
    TabLoadingScopeComponent,
    ActivityTickerComponent,
  ],
  // The Syncfusion DocumentEditor services moved onto TextPreviewComponent itself. Naming them
  // here kept @syncfusion/ej2-angular-documenteditor (7.5 MB) in the eager bundle for every page.
  providers: [
    HeaderEmailSidebarService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
